import gql from 'graphql-tag';
import { getFYList } from '../../../util/shared/tmc-global';
import { clients } from '../../../util/clients';
// import { fieldsToGqlString } from '../../../util/shared/vue-global';

const { backend } = clients.direct;

export const taxCommon = {
  namespaced: true,
  state: () => ({
    taxYearList: [],
    fiscalYearList: [],
    latestTaxYear: 0,
    latestFiscalYear: 0,
  }),
  mutations: {
    setTaxYearList(state, list) {
      state.taxYearList = list;
    },
    setFiscalYearList(state, list) {
      state.fiscalYearList = list;
    },
    setLatestTaxYear(state, list) {
      state.latestTaxYear = list;
    },
    setLatestFiscalYear(state, list) {
      state.latestFiscalYear = list;
    },
  },
  getters: {
  },
  actions: {
    async loadTaxYearList({ commit, dispatch }, {
      postProcessTrans,
      allowAll = true, dontCommit = true,
    }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`{
            taxInquiryStatsRange { max, min }
          }`,
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { taxInquiryStatsRange } = results.data;
          const taxYearList = getFYList(taxInquiryStatsRange, allowAll);
          if (taxYearList.length > 0) {
            const [highestYear] = taxYearList.sort((a, b) => b - a);
            commit('setLatestTaxYear', highestYear);
          }
          const processedTransData = postProcessTrans
            ? postProcessTrans(taxYearList) : taxYearList;
          if (dontCommit) commit('setTaxYearList', processedTransData);

          return processedTransData;
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting min/max date ranges.', { root: true });
      }
      return {};
    },
    async loadFiscalYearList({ commit, dispatch }, { postProcessTrans, allowAll = true }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`{
            taxPaymentsStatsRange { max, min }
          }`,
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { taxPaymentsStatsRange } = results.data;
          const taxFiscalList = getFYList(taxPaymentsStatsRange, allowAll);
          if (taxFiscalList.length > 0) {
            const [highestYear] = taxFiscalList.sort((a, b) => b - a);
            commit('setLatestFiscalYear', highestYear);
          }
          const processedTransData = postProcessTrans
            ? postProcessTrans(taxFiscalList) : taxFiscalList;
          commit('setFiscalYearList', processedTransData);
          return processedTransData;
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting min/max date ranges.', { root: true });
      }
      return [];
    },
  },
};

export default taxCommon;
